import React, { useState } from 'react';
import axios from 'axios';
import { baseurl } from '../Url';

const CulturalForm = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    number: '',
    CulturalActivity: '',
    message: '',
    email: ''
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.number || !formData.email) {
      setErrorMessage('Please fill out all details correctly first');
    } else {
      setErrorMessage('Please wait...');
      axios.post(`${baseurl}/culturaltourism`, formData)
        .then(response => {
          setErrorMessage('Booking successful!');
          alert("Thank You for your response. We will contact you soon");
        })
        .catch(error => {
          console.error('There was an error!', error);
          alert("Booking failed, There might be some glitch,Please try again...");
        });
    }
  };

  return (
    <div className='m-2'>
      <div className="my-2 h-28 items-center flex flex-col justify-center">
        <img className='h-24' src="/assets/logo/kdd343.png" alt="/" />
        <p className='tagline text-xs px-1 rounded-lg flex font-bold shadow-sm capitalize'>
          <span className='text-green-500'>Travel.</span>
          <span className='text-orange-400'>Culture.</span>
          <span className='text-blue-500'>India.</span>
        </p>
      </div>
      <form className='text-lg' onSubmit={handleSubmit} id='culturalform'>
        <div className='flex justify-center text-center items-center'>
          <label className='w-[120px] lg:w-[200px] formbox text-lg'>Name:</label>
          <input
            className='w-[200px] lg:w-[200px] formbox text-lg'
            name='name'
            value={formData.name}
            onChange={handleInput}
            type="text"
            placeholder='Your Name'
          />
        </div>
        <div className='flex justify-center text-center items-center'>
          <label className='w-[120px] lg:w-[200px] formbox text-lg'>Contact:</label>
          <input
            className='w-[200px] lg:w-[200px] formbox text-lg'
            name='number'
            value={formData.number}
            onChange={handleInput}
            type="text"
            placeholder='Your Number'
          />
        </div>
        <div className='flex justify-center text-center items-center'>
          <label className='w-[120px] lg:w-[200px] formbox text-lg'>Email id:</label>
          <input
            className='w-[200px] lg:w-[200px] formbox text-lg'
            name='email'
            value={formData.email}
            onChange={handleInput}
            type="email"
            placeholder='Email id'
          />
        </div>
        <div className="text-center flex justify-center items-center">
          <label className="lg:w-[200px] formbox w-[120px] text-lg">Activity:</label>
          <select
            className="formbox lg:w-[200px] w-[200px]"
            name="CulturalActivity"
            value={formData.CulturalActivity}
            onChange={handleInput}
          >
            
            <option value="">Select an activity</option>

            <option value="Bhawai Dance">Bhawai Dance</option>
            <option value="Parda Dance">Parda Dance</option>
            <option value="Rajasthani Folk Bollywood">Rajasthani Folk Bollywood</option>
            <option value="Chari Dance">Chari Dance</option>
            <option value="Kalbeliya Dance">Kalbeliya Dance</option>
            <option value="Taraju Dance">Taraju Dance</option>
            <option value="Gajal Qawalli Songs">Gajal Qawalli Songs</option>
            <option value="All">All</option>
          
          </select>
        </div>
        <div className='flex gap-2 justify-center text-center items-center'>
          <label className='w-[120px] lg:w-[200px] formbox text-lg'>Message:</label>
          <textarea
            className='w-[200px] lg:w-[200px] formbox text-lg'
            name='message'
            value={formData.message}
            onChange={handleInput}
            placeholder='Message for us..'
          />
        </div>
        {errorMessage && <p className='py-2' style={{ color: 'red' }}>{errorMessage}</p>}
        <div className='items-center text-center'>
          <button type='submit' className='btn hover:translate-y-2 rounded-xl'>Submit</button>
        </div>
      </form>
    </div>
  );
}

export default CulturalForm;
